import { useEffect, useState } from "react";
import { _ACTIVITIES, _ROLES_BACK } from "../../utils/constants";
import { _ROUTES } from "../../utils/_routes_constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { AgGridVolumeFilaire } from "../../components/budget/sales-filaire/AgGridVolumeFilaire";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";
import {
  SALES_FILAIRE_TOTAL_VALUE,
  SALES_FILAIRE_TOTAL_VOLUME,
  SAVE_CATEGORY,
  SAVE_DATA_SALES_FILAIRE,
} from "../../utils/savedDataConstant/inputSalesFilaireSaveConstants";

export const InputSaleFilaire = () => {
  const [saveData, setSaveData] = useState([]);
  const [rowsData, setRowsData] = useState([]);
  const [params, setParams] = useState({});

  useEffect(() => {
    if (saveData.length > 0) {
      const modifiedData = saveData
        ?.map((d) => {
          if (!d) return null;

          const payload = {
            activityName: _ACTIVITIES.FILAIRE,
            siteId: params.site,
            theme: d.rowName,
            months: {},
          };

          for (let i = 1; i <= 12; i++) {
            payload.months[i] = d[i] || null;
          }

          return payload;
        })
        .filter((item) => item !== null);

      sendToFinancialData(modifiedData, SAVE_CATEGORY, () => {
        setSaveData([]);
      });
    }
  }, [saveData, params.site]);

  const handleParamsChange = (newParams) => {
    setParams(newParams);
  };

  const handleOnSaveDataBefore = (gridRef, rowData) => {
    const aggregationRows = [];

    // Get all rendered nodes (visible rows)
    const renderedNodes = gridRef.current.api.getRenderedNodes();

    // Filter for group total rows
    renderedNodes.forEach((node) => {
      if (node.group && node.footer) {
        const aggregationRow = {
          ...node.aggData,
          rowName:
            node.key === "VOLUME"
              ? SALES_FILAIRE_TOTAL_VOLUME
              : SALES_FILAIRE_TOTAL_VALUE,
        };

        aggregationRows.push(aggregationRow);
      }
    });

    return aggregationRows;
  };

  return (
    <BaseBudgetInput
      title="Input Sales Volume Filaire"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      userRole={_ROLES_BACK._ROLE_SALES}
      enableFlag="dataEntryEnableSales"
      TableComponent={AgGridVolumeFilaire}
      tableComponentProps={{
        rowsData,
        setRowsData,
        params,
      }}
      saveData={saveData}
      setSaveData={setSaveData}
      onSaveDataBefore={handleOnSaveDataBefore}
      onParamsChange={handleParamsChange}
      includeBaseBudgetSave={true}
      saveNameCategory={SAVE_CATEGORY}
      arrayData={SAVE_DATA_SALES_FILAIRE}
      filters={[
        {
          key: "site",
          route: _ROUTES.SITES,
          defaultValue: "",
          label: "Site",
          queryParams: {
            pagination: false,
            active: 1,
            "order[name]": "ASC",
            "activities.name": _ACTIVITIES.FILAIRE,
            "groups[]": "select:get",
          },
        },
      ]}
    />
  );
};
